import {Button, message, Space} from "antd";
import {StyledAccountDetailsFormLayoutInfoWrapper} from "../form/layout/styles";
import {usePayoutSettingsContext} from "../context";
import {StyledOtpInput, StyledPayoutDetailsBox, StyledTextButton} from "./styles";
import {CurrentAccountDetailsBox} from "../form/layout";
import {Dispatch, FormEvent, SetStateAction, useEffect, useState} from "react";
import OTPInput from "react-otp-input";
import {useUpdateBank} from "../form/hooks/update-bank";
import {useInitiateStripeUpdate} from "../../../../../../features/bank-accounts/hooks/useStripeActions";
import {useInitiateUpdateBankAccount} from "../../../../../../features/bank-accounts/hooks/useBankAccounts";

export function AccountDetailsOTPView() {
  const {state, dispatch} = usePayoutSettingsContext();
  const [otp, setOtp] = useState("");
  const {isUpdatingBank, updateBank, updateStripeBank} = useUpdateBank();
  const payoutCountry = state.payoutCountries.countries.find(
    (c) => c.code === state.selectedCountryCode
  );

  function handleVerifyAccountDetails(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (state.updateType === "local") {
      if (state.connectBankFormValues && state.selectedCountryCode) {
        updateBank({
          accountNumber: state.connectBankFormValues.accountNumber,
          bankCode: state.connectBankFormValues.bankCode,
          countryCode: state.selectedCountryCode,
          branchCode: state.connectBankFormValues.branchCode,
          otp,
        });
      } else {
        message.error("Some values are missing");
      }
    } else if (state.updateType === "stripe") {
      updateStripeBank({otp});
    } else {
      message.error("Update type not set");
    }
  }
  return (
    <StyledAccountDetailsFormLayoutInfoWrapper>
      <StyledPayoutDetailsBox>
        <p className="bold-text">Payout details:</p>
        {state.updateType === "local" ? (
          state.connectBankFormValues &&
          state.accountName &&
          state.bankName && (
            <CurrentAccountDetailsBox
              accountName={state.accountName}
              bankName={state.bankName}
              accountNumber={state.connectBankFormValues.accountNumber}
            />
          )
        ) : (
          <CurrentAccountDetailsBox
            accountName={payoutCountry ? payoutCountry.name : ""}
            bankName={null}
          />
        )}

        <p>
          Wrong details?{" "}
          <StyledTextButton
            onClick={() => {
              dispatch({
                type: "update-payment-settings-flow",
                payload: {
                  currentView: "form",
                  type: "update",
                },
              });
            }}
            type="text"
            size="small"
          >
            <span className="text-underline">Edit</span>
          </StyledTextButton>
        </p>
      </StyledPayoutDetailsBox>
      <form onSubmit={handleVerifyAccountDetails}>
        <Space size={24} direction="vertical" style={{display: "flex"}}>
          <div>
            <OTPInputBox otp={otp} setOtp={setOtp} />
          </div>
          <OTPTimer selectedCountryCode={state.selectedCountryCode} />
          <div>
            <Button
              htmlType="submit"
              type="primary"
              size="small"
              disabled={otp.length < 6}
              loading={isUpdatingBank}
            >
              Verify account details
            </Button>
          </div>
        </Space>
      </form>
    </StyledAccountDetailsFormLayoutInfoWrapper>
  );
}

function OTPTimer({selectedCountryCode}: {selectedCountryCode: string | null}) {
  const {state} = usePayoutSettingsContext();
  const [timer, setTimer] = useState(30);
  const initiateUpdateBankAccountMutation = useInitiateUpdateBankAccount();
  const initiateStripeUpdateMutation = useInitiateStripeUpdate();

  function handleResendOTP() {
    if (!selectedCountryCode) {
      message.error("No country selected");
      return;
    }
    if (state.updateType === "local") {
      if (!state.connectBankFormValues) {
        message.error("Some values are missing");
        return;
      }
      // v2 two-step flow: re-invoke the same initiate mutation used for the
      // first OTP send (initiateUpdateBankAccount) instead of the retired
      // v1 otp/send endpoint.
      initiateUpdateBankAccountMutation.mutate(
        {
          ...state.connectBankFormValues,
          bankName: state.bankName ?? "",
        },
        {
          onSuccess: () => {
            setTimer(30);
          },
        }
      );
    } else {
      initiateStripeUpdateMutation.mutate(
        {countryCode: selectedCountryCode},
        {
          onSuccess: () => {
            setTimer(30);
          },
        }
      );
    }
  }

  useEffect(() => {
    const timerCount = setInterval(() => {
      if (timer > 0) setTimer(timer - 1);
    }, 1000);
    return () => clearInterval(timerCount);
  }, [timer]);
  return (
    <div>
      {timer > 0 ? (
        <p className="bold-text">{timer} secs</p>
      ) : (
        <div>
          <StyledTextButton type="text" size="small" onClick={() => handleResendOTP()}>
            <span className="text-underline">Resend OTP</span>
          </StyledTextButton>
        </div>
      )}
    </div>
  );
}

function OTPInputBox({
  otp,
  setOtp,
}: {
  otp: string;
  setOtp: Dispatch<SetStateAction<string>>;
}) {
  return (
    <div>
      <Space size={24} direction="vertical" style={{display: "flex"}}>
        <p>Please enter the OTP that has been sent to your email address</p>
        <OTPInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderSeparator={<span>-</span>}
          renderInput={(props) => <StyledOtpInput {...props} />}
          // inputStyle={{
          //   width: "3rem",
          //   height: "3rem",
          //   borderRadius: "2px",
          //   border: "1px solid #D9D9D9",
          // }}
        />
      </Space>
    </div>
  );
}
